import React, { forwardRef } from 'react';
import { Image as WebImage } from 'react-native-web';
import { optimizeImageUri, useCloudinarySource } from './cloudinary';

const MODES = { cover: 'cover', contain: 'contain', fill: 'stretch', none: 'center', 'scale-down': 'contain' };

function normalize(source, style?) {
  if (source && typeof source === 'object' && typeof source.src === 'string') return { uri: source.src, width: source.width, height: source.height };
  if (source && typeof source === 'object' && source.default && typeof source.default.src === 'string') return { uri: source.default.src };
  if (source && typeof source === 'object' && typeof source.uri === 'string') return { ...source, uri: optimizeImageUri(source.uri, style) };
  return source;
}

/** expo-image's <Image>, drawn with the browser's own image: contentFit becomes resizeMode. */
export const Image = forwardRef<any, any>(function Image({ source, contentFit = 'cover', transition, placeholder, cachePolicy, recyclingKey, priority, ...rest }, ref) {
  const sized = useCloudinarySource(source, rest.style, rest.onLayout);
  return <WebImage ref={ref} resizeMode={MODES[contentFit] || 'cover'} {...rest} source={normalize(sized.source, rest.style)} onLayout={sized.onLayout} />;
});

export default Image;
